import styles from '@modules/modules/CookieConsent/CookieConsent.module.scss';
import ConsentService from '@modules/modules/CookieConsent/components/ConsentService';
import Button from '@ui/components/Button/Button';
import Content from '@ui/components/Content/Content';
import Heading from '@ui/components/Heading/Heading';
import Switch from '@ui/components/Switch/Switch';
import React, { memo, useEffect, useRef, useState } from 'react';
import {
  Disclosure,
  DisclosureContent,
  FormGroup,
  useCheckboxStore,
  useDisclosureStore,
} from '@ariakit/react';
import classNames from 'classnames';

const ConsentGroup = memo(
  ({ store, id, description, title, services, isGroupVisible }) => {
    const [groupVal, setGroupVal] = useState();
    const handleSetGroupVal = value => {
      services.forEach(({ id: serviceId }) => {
        store.setValue(`${id}.${serviceId}`, !!value);
      });
      setGroupVal(value);
    };
    const checkbox = useCheckboxStore({
      value: groupVal,
      setValue: handleSetGroupVal,
    });
    const disclosure = useDisclosureStore();
    const contentRef = useRef(null);
    const { mounted, open } = disclosure.useState();

    store.useValidate(({ values }) => {
      if (
        services.length !==
        Object.keys(values[id]).filter(key => values[id][key]).length
      ) {
        setGroupVal(null);
      } else {
        setGroupVal(id);
      }
    });

    useEffect(() => {
      if (isGroupVisible) {
        disclosure.show();
      }
    }, [isGroupVisible]);

    useEffect(() => {
      if (mounted && contentRef.current) {
        contentRef.current.focus();
      }
    }, [mounted]);

    const getServiceCountText = () => {
      const n = services.length;

      return `(${n} Fremd-Dienst${
        n > 1 ? 'e' : ''
      }: Details beim Ausklappen sichtbar)`;
    };

    return (
      <div className={styles.group}>
        <div className={styles.groupHeader}>
          <div>
            <Heading as="h2" className={styles.groupTitle} noSpacing size="h6">
              {title}
            </Heading>
            <span className={styles.serviceCount}>{getServiceCountText()}</span>
          </div>
          <Switch
            aria-label={`${title} akzeptieren`}
            store={checkbox}
            value={id}
          />
        </div>
        <div className={classNames(styles.serviceCount, styles.mobile)}>
          ({services.length}{' '}
          {services.length > 1 ? 'Fremd-Dienste:' : 'Fremd-Dienst:'} Details
          beim Ausklappen sichtbar)
        </div>
        <Content className={styles.groupDescription} size="md">
          {description}
        </Content>
        <Disclosure
          className={styles.groupToggle}
          render={
            <Button theme="secondary" variant="link">
              {open ? 'Weniger ' : 'Mehr '}Anzeigen
            </Button>
          }
          store={disclosure}
        />

        <DisclosureContent store={disclosure}>
          <FormGroup name={store.names[id]} store={store}>
            <div ref={contentRef}>
              {services.map(item => (
                <ConsentService
                  company={item.company}
                  dependencies={item.dependencies}
                  details={item.details}
                  groupId={id}
                  id={item.id}
                  key={item.id}
                  name={item.name}
                  store={store}
                  via={item.via}
                />
              ))}
            </div>
          </FormGroup>
        </DisclosureContent>
      </div>
    );
  },
);

ConsentGroup.displayName = 'ConsentGroup';

export default ConsentGroup;
